















import {Component, Prop, Vue} from 'vue-property-decorator';
import ColumnIcon from 'vue-material-design-icons/ViewColumn.vue';
import DataTableColumn from './dataTableColumn';
import MultiSelectPicker from '@/shared/components/MultiSelectPicker.vue';

@Component({
	components: {
		MultiSelectPicker,
		ColumnIcon
	}
})
export default class ColumnPicker extends Vue {
	@Prop() public columns: DataTableColumn[];
	@Prop() public value: DataTableColumn[];

	public onInput(newValue: DataTableColumn[]) {
		this.$emit('input', newValue);
	}
}
